<template>
  <div class="relative-parent">
    <input
      :id="this.id"
      ref="inputRef"
      type="text"
      @input="this.updateSize()"
      @focus="onFocus($event.target.id)"
      @blur="onBlur($event.target.id)"
      :placeholder="placeholder"
      :class="[
        'form-control autosized-input text-hover input-focus',
        hasError === true ? 'is-invalid' : 'form-control-transparent',
      ]"
      readonly
    />
    <span :id="`Size${this.id}`" class="ps-5 size-calibration"></span>
  </div>
</template>

<script>
import { useCurrencyInput } from "vue-currency-input";
import { watch } from "vue";

export default {
  name: "FocusCurrencyInput",
  emits: ["update:modelValue", "isFocus", "change"],
  props: {
    id: String,
    modelValue: [String, Number],
    options: Object,
    placeholder: { type: String, required: false },
    hasError: { type: Boolean, required: false, default: false },
  },
  setup(props) {
    const { inputRef, setValue } = useCurrencyInput(props.options);

    watch(
      () => props.modelValue,
      (value) => {
        setValue(value);
      }
    );

    return { inputRef };
  },
  methods: {
    updateSize() {
      const span = document.getElementById(`Size${this.id}`);
      const input = document.getElementById(this.id);
      if (span != null && input != null) {
        span.innerText = input.value;
      }
    },
    onFocus(id) {
      this.$emit("isFocus", true);
      document.getElementById(id).classList.remove("form-control-transparent");
      document.getElementById(id).removeAttribute("readonly");
      document.getElementById(id).select();

      // var input = document.getElementById(id);
      // setTimeout(() => {
      //   input.selectionStart = input.selectionEnd = input.value.length;
      // }, 80);
    },
    onBlur(id) {
      this.$emit("isFocus", false);
      if (this.hasError === false) {
        document.getElementById(id).classList.add("form-control-transparent");
      }
      document.getElementById(id).setAttribute("readonly", true);
    },
  },
  mounted() {
    this.updateSize();
  },
};
</script>

<style>
.relative-parent {
  position: relative;
  min-width: 1em;
  width: min-content;
  height: 43px;
}

.size-calibration {
  visibility: hidden;
  white-space: pre;
  position: relative;
}

.autosized-input {
  position: absolute;
  left: 0;
  width: 100%;
}

.size-calibration,
.autosized-input {
  font-family: Poppins, Helvetica, "sans-serif";
  padding: 0.75rem 1rem;
  font-size: 1.1rem;
}

.text-hover:hover {
  color: black;
}
</style>
